import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const trackerFiltersSelector = createSelector(selfSelector, (trackerStats) => trackerStats.filter);

export default trackerFiltersSelector;
